/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import {
  Button,
  Dialog, DialogContent, DialogTitle, Divider, Grid, Modal,
  Switch,
  Typography,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { KeyboardDateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import { Alert } from '@material-ui/lab';
import useEvaluoExam from './useEvaluoExam';
import SwitchParameter from './SwitchParameter';
import SelectParameter from './SelectParameter';
import {
  plagiarismType, proctoringTypeOptions, secureLevelId, secureTypeId,
} from './utilsEvaluo';
import { Loading } from '../../../../helpers/utils';

const minDate = new Date(new Date().getFullYear(), new Date().getUTCMonth(), new Date().getDate() + 21, 9, 0, 0, 0);
const maxDate = new Date(new Date().getFullYear(), new Date().getUTCMonth(), new Date().getDate() + 21, 11, 0, 0, 0);
const durations = [{ label: '30min', value: 30 }, { label: '1h', value: 60 }, { label: '1h30', value: 90 }, { label: '2h', value: 120 }];

const customStyles = {
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused || state.isSelected ? '#deebff' : 'white',
    color: 'black',
    width: '100%',
    fontSize: '14px',
  }),
  control: (base, state) => ({
    ...base,
    minHeight: '45px',
    fontSize: '14px',
    boxShadow: state.isFocused ? '0 0 0 1px #002984' : 0,
  }),
  menu: (provided) => ({ ...provided, zIndex: 98 }),
};

const UpdateEvaluoExam = ({
  open,
  setOpen,
  examData,
  company,
  setLoadingList,
  refresh,
  setRefresh,
  allSubjects,
}) => {
  // const classes = useStyles();
  const [loading, setLoading] = useState(true);
  const [catchUp, setCatchUp] = useState(false);
  const [modalities, setModalities] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [subject, setSubject] = useState({});
  const [oldSubjectId, setOldSubjectId] = useState(0);
  const today = new Date();
  const [minimumDeliveryDate, setMinimumDeliveryDate] = useState(new Date(today.getFullYear(), today.getUTCMonth(), today.getDate() + 42, 9, 0, 0, 0));
  const [form, setForm] = useState({
    modality: { label: 'Evaluo écrit', value: 1 },
    beginDate: new Date(examData?.temporality?.start_at) || minDate,
    endDate: new Date(examData?.temporality?.end_at) || maxDate,
    duration: durations[2],
    semester: examData.semester,
    deliveryDate: minimumDeliveryDate,
    identifyPortrait: false,
    identifyPaper: false,
    identifyEnvironment: false,
    identifyValidationRequired: false,
    studentLock: false,
    waitingTime: '00:00:00',
    proctoring: false,
    proctoringTypeId: 0,
    proctoringCamera: false,
    proctoringScreen: false,
    secure: false,
    secureTypeId: 0,
    secureLevelId: 0,
    secureClipboard: false,
    secureDualscreen: false,
    secureFullscreen: false,
    plagiarismType: 0,
    studentRetake: false,
    attendanceSignature: false,
  });
  const { updateEvaluoExam } = useEvaluoExam(company, refresh, setRefresh);

  useEffect(() => {
    if (examData) {
      setCatchUp(!!examData.name?.includes('Rattrapage'));
      setForm({
        modality: { label: 'Evaluo écrit', value: 1 },
        beginDate: new Date(examData?.temporality?.start_at) || minDate,
        endDate: new Date(examData?.temporality?.end_at) || maxDate,
        duration: durations[2],
        semester: examData.semester,
        deliveryDate: minimumDeliveryDate,
        identifyPortrait: examData.identify?.portrait || false,
        identifyPaper: examData.identify?.paper || false,
        identifyEnvironment: examData.identify?.environment || false,
        identifyValidationRequired: examData.identify?.validation_required || false,
        studentLock: examData.supervisor?.student_lock || false,
        waitingTime: '00:00:00',
        proctoring: !!examData.proctoring?.type?.id,
        proctoringTypeId: { label: examData.proctoring?.type?.name || '', value: examData.proctoring?.type?.id || 0 },
        proctoringCamera: examData.proctoring?.camera || false,
        proctoringScreen: examData.proctoring?.screen || false,
        secure: examData.secure?.type?.id !== 0 && examData.secure?.type !== null,
        secureTypeId: { label: examData.secure?.type?.name || 'Pas de sécurité', value: examData.secure?.type?.id || 0 },
        secureLevelId: { label: examData.secure?.level?.name || '', value: examData.secure?.level?.id || null },
        secureClipboard: examData.secure?.clipboard || false,
        secureDualscreen: examData.secure?.dualscreen || false,
        secureFullscreen: examData.secure?.fullscreen || false,
        plagiarismType: 0,
        studentRetake: examData.student?.retake || false,
        attendanceSignature: examData.attendance?.signature || false,
      });
      const subjectsArr = [];
      let found = false;
      allSubjects.forEach((subjectItem) => {
        if (subjectItem.name.includes(`S${examData.semester}`) && subjectItem.state.name !== 'Désactivé') {
          subjectsArr.push({ label: subjectItem.name, value: subjectItem.id });
        }
        if (examData.subjects
          && examData.subjects.length > 0
          && examData.subjects[0]?.subject?.id
          && subjectItem.id === examData.subjects[0]?.subject?.id) {
          found = true;
          setSubject({ label: subjectItem.name, value: subjectItem.id });
          setOldSubjectId(examData.subjects[0]?.subject?.id);
        }
      });
      setSubjects(subjectsArr);
      if (!found) {
        setSubject(subjectsArr[0]);
      }
      setLoading(false);
    }
  }, [examData]);

  useEffect(() => {
    if (form.beginDate !== undefined) {
      const tmp = new Date(form.endDate);
      const tmpEnd = new Date(form.endDate);
      const tmpBegin = new Date(form.beginDate);
      tmp.setDate(tmp.getDate() + 21);
      setMinimumDeliveryDate(tmp);
      if (tmpBegin.getDate() > tmpEnd.getDate()) {
        tmpBegin.setHours(tmpBegin.getHours() + 1);
        setForm({ ...form, deliveryDate: tmp, endDate: tmpBegin });
      } else {
        setForm({ ...form, deliveryDate: tmp });
      }
    }
  }, [form.beginDate, form.endDate]);

  useEffect(() => {
    if (form.semester !== undefined) {
      setForm({ ...form, modality: { label: 'Evaluo écrit', value: 1 } });
      setModalities([
        // ...form.semester.examModalities,
        { label: 'Evaluo écrit', value: 1 },
        // { label: 'Evaluo oral', value: 2 },
        // { label: 'Evaluo intégré', value: 3 },
      ]);
    }
  }, [form.semester]);

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      fullWidth
      maxWidth="lg"
    >
      <DialogTitle>
        Update Evaluo exam
      </DialogTitle>
      {!loading ? (
        <DialogContent style={{
          display: 'flex', flexDirection: 'column', alignContent: 'flex-start', gap: '20px',
        }}
        >
          <Grid container spacing={2}>
            <Grid item md={12}>
              <Alert severity="info">
                L&apos;utilisation de ce service entraînera des frais supplémentaires,
                veuillez contacter notre service commercial afin d&apos;obtenir la grille tarifaire
              </Alert>
            </Grid>
          </Grid>
          <Grid container spacing={2} style={{ marginTop: '15px' }}>
            <Grid item md={2}>
              <Select
                value={form.semester}
                placeholder={`Semester ${form.semester}`}
                isDisabled
              />
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item md={3}>
              <MuiPickersUtilsProvider utils={MomentUtils} locale="fr">
                <KeyboardDateTimePicker
                  required
                  inputMode="none"
                  InputProps={{ readOnly: true }}
                  autoOk
                // error={errors.date}
                  disablePast
                  format="DD/MM/YYYY - HH:mm"
                  fullWidth
                  onChange={(e) => { setForm({ ...form, beginDate: e }); }}
                  value={form.beginDate}
                  helperText={"Date et heure de début de l'examen"}
                />
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid item md={3}>
              <MuiPickersUtilsProvider utils={MomentUtils} locale="fr">
                <KeyboardDateTimePicker
                  required
                  autoOk
                //   error={errors.date}
                  disablePast
                  InputProps={{ readOnly: true }}
                  format="DD/MM/YYYY - HH:mm"
                  fullWidth
                  onChange={(e) => { setForm({ ...form, endDate: e }); }}
                  value={form.endDate}
                  helperText={"Date et heure de fin de l'examen"}
                />
              </MuiPickersUtilsProvider>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item md={5}>
              <Select
                value={form.modality}
                styles={customStyles}
                options={modalities}
                placeholder="Modalité"
                onChange={(e) => { setForm({ ...form, modality: e }); }}
              />
            </Grid>
            <Grid item md={5}>
              <Select
                value={subject}
                styles={customStyles}
                options={subjects}
                placeholder="Sujet"
                onChange={(e) => {
                  setSubject(e);
                }}
              />
            </Grid>
            {(form.modality !== undefined
            && (form.modality.label === 'Quiz automatisé'
              || (form.modality.label === 'Sur la plateforme' && form.semester.value !== 6)
              || form.modality.label === 'Evaluo écrit'
              || form.modality.label === 'Evaluo oral'
              || form.modality.label === 'Evaluo intégré'
            ))
            && (
              <Grid item md={2} style={{ alignItems: 'center' }}>
                <Select
                  value={form.duration}
                  styles={customStyles}
                  options={durations}
                  placeholder="Durée"
                  onChange={(e) => { setForm({ ...form, duration: e }); }}
                />
              </Grid>
            )}
          </Grid>
          <Grid container spacing={2}>
            <Grid
              item
              md={12}
              style={{
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'center',
              }}
            >
              <Typography
                variant="body1"
              >
                Rattrapage
              </Typography>
              <Switch
                checked={catchUp}
                onChange={() => { setCatchUp(!catchUp); }}
                name="checkRecurent"
                Gridor="primary"
                size="small"
              />
            </Grid>
          </Grid>

          <Grid container spacing={2} style={{ marginTop: '15px' }}>
            <Grid item md={10}>
              <Typography
                variant="body1"
                style={{
                  fontWeight: 'bold',
                  color: '#DC5959',
                }}
              >
                {'Attention, le retour des notes se fera 3 semaines après la réalisation de l\'examen.'}
              </Typography>
            </Grid>
          </Grid>
          <Divider style={{ width: '100%' }} />
          <Grid container spacing={2}>
            <SwitchParameter
              form={form}
              setForm={setForm}
              parameter="attendanceSignature"
              label="Signatures"
            />
            <SwitchParameter
              form={form}
              setForm={setForm}
              parameter="identifyPortrait"
              label="Prise photo d'identité"
            />
            <SwitchParameter
              form={form}
              setForm={setForm}
              parameter="identifyPaper"
              label="Photo papier d'identité"
            />
            <SwitchParameter
              form={form}
              setForm={setForm}
              parameter="identifyEnvironment"
              label="Identifier l'environnement"
            />
            <SwitchParameter
              form={form}
              setForm={setForm}
              parameter="identifyValidationRequired"
              label="Validation de l'identité requise pour entrer dans la salle"
            />
            <SwitchParameter
              form={form}
              setForm={setForm}
              parameter="studentLock"
              label="Blocage des étudiants"
            />
          </Grid>
          <SwitchParameter
            form={form}
            setForm={setForm}
            parameter="studentRetake"
            label="Possibilité de refaire l'examen"
          />
          <SelectParameter
            form={form}
            setForm={setForm}
            parameter="plagiarismType"
            placeholder="Type d'anti plagiat"
            options={plagiarismType}
          />
          <Divider style={{ width: '100%' }} />
          <Grid container spacing={2}>
            <SwitchParameter
              form={form}
              setForm={setForm}
              parameter="proctoring"
              label="Surveillance"
            />
            {form.proctoring && (
            <SelectParameter
              form={form}
              setForm={setForm}
              parameter="proctoringTypeId"
              placeholder="Type de surveillance"
              options={proctoringTypeOptions}
            />
            )}
            {form.proctoring && (
            <SwitchParameter
              form={form}
              setForm={setForm}
              parameter="proctoringCamera"
              label="Surveillance par caméra"
            />
            )}
            {form.proctoring && (
            <SwitchParameter
              form={form}
              setForm={setForm}
              parameter="proctoringScreen"
              label="Surveillance de l'écran"
            />
            )}
          </Grid>
          <Divider style={{ width: '100%' }} />
          <Grid container spacing={2}>
            <SwitchParameter
              form={form}
              setForm={setForm}
              parameter="secure"
              label="Sécurité"
            />
            {form.secure && (
            <SelectParameter
              form={form}
              setForm={setForm}
              parameter="secureLevelId"
              placeholder="Niveau de sécrité"
              options={secureLevelId}
            />
            )}
            {form.secure && (
            <SwitchParameter
              form={form}
              setForm={setForm}
              parameter="secureDualscreen"
              label="Bloquer écran double"
            />
            )}
            {form.secure && (
            <SwitchParameter
              form={form}
              setForm={setForm}
              parameter="secureFullscreen"
              label="Forcer le plein écran"
            />
            )}
            {(form.secure && (form.secureLevelId.value === 2 || form.secureLevelId.value === 3)) && (
            <SwitchParameter
              form={form}
              setForm={setForm}
              parameter="secureClipboard"
              label="Bloquer copier/coller"
            />
            )}
          </Grid>
          <Divider style={{ width: '100%' }} />
          <Grid container spacing={2}>
            <Grid item md={9} />
            <Grid item md={2}>
              <Button
                disableElevation
                onClick={() => {
                  setLoadingList(true);
                  updateEvaluoExam(examData.id, form, subject, oldSubjectId);
                  setOpen(false);
                }}
                style={{ marginTop: '1.5em', padding: '1em 0 1em 0' }}
                variant="contained"
                color="primary"
                fullWidth
              >
                Mettre à jour
              </Button>
            </Grid>
          </Grid>
          {/* </div> */}
        </DialogContent>
      )
        : <Loading />}
    </Dialog>
  );
};

export default UpdateEvaluoExam;
